import React from 'react'
import Home from './Home'
import Courses from './Courses'
import Cours from './Cours'
import About from './About'
import Formulaire from './Formulaire'
import Tarif from './Tarif'
// import MyCalendar from './Agenda'

function MainContent() {


	return (
		<>
			<Home />
			<About />
			<Courses />
			<Cours/>
			{/* <MyCalendar /> */}
			<Tarif />
			<Formulaire />
		</>
	)
}

export default MainContent
